// export default ShowRdv;
import React, { useState } from "react";
import Button from "react-bootstrap/Button";
import Offcanvas from "react-bootstrap/Offcanvas";
import { Formik, Form, Field, ErrorMessage } from "formik";
import FormBootstrap from "react-bootstrap/Form";
import {
  formatFrenchDate,
  lieuIntervention,
  StatusRdv,
} from "../../utils/utils";
import {
  cancelRdvManual,
  fetchCalendarData,
} from "../../store/slices/rendezVousPrestaSlice";
import { useDispatch } from "react-redux";
import Popup from "../Popup";
import { useSelector } from "react-redux";

function ShowRdvManual({
  handleShow,
  handleClose,
  setEditManual,
  show,
  ...props
}) {
  // console.log("props.event in show page:", props?.event);
  const [isPopupVisible, setPopupVisible] = useState(false);
  const [popupActionType, setPopupActionType] = useState(null); // 'Rendez-vous manuelle' or 'Indisponibilité'
  const rendezVous = props?.event;
  const locationIcons = lieuIntervention();
  const statusIcons = StatusRdv();
  const { allEtablissementEquipes } = useSelector((state) => state.rdvPresta);
  const dispatch = useDispatch();

  const handlePopupAction = () => {
    dispatch(
      cancelRdvManual({
        id: rendezVous.id,
        status: "annule",
      })
    )
      .unwrap()
      .then(() => {
        dispatch(fetchCalendarData());
        setPopupVisible(false);
        handleClose();
      })
      .catch((error) => {
        // console.error("Erreur lors de l'annulation :", error);
      });
    setPopupVisible(false);
  };
  // console.log("rendezVous.title", rendezVous?.title);
  return (
    <>
      <Offcanvas
        show={show}
        onHide={handleClose}
        {...props}
        placement="end"
        className="showRdv"
      >
        <Offcanvas.Header closeButton>
          {rendezVous?.type == "manual_user" ? (
            <Offcanvas.Title className="agendaTiltle">
              Détails du rendez-vous
            </Offcanvas.Title>
          ) : (
            <Offcanvas.Title className="agendaTiltle">
              Détails de l’indisponibilité
            </Offcanvas.Title>
          )}
        </Offcanvas.Header>
        <Offcanvas.Body>
          <Formik initialValues={rendezVous} onSubmit={() => {}}>
            {() => (
              <Form className="m-24">
                {rendezVous?.type == "manual_user" ? (
                  <div className="mb-16">
                    <span>
                      <img
                        src={locationIcons[rendezVous?.lieu_intervention]}
                        alt={rendezVous?.lieu_intervention}
                      />
                    </span>
                  </div>
                ) : null}
                <h5 className="mb-8">
                  {" "}
                  {formatFrenchDate(rendezVous?.start_time)}{" "}
                  <img
                    className="separator"
                    src="/images/separateur.svg"
                    alt="separateur"
                  />{" "}
                  {new Date(rendezVous?.start_time).toLocaleTimeString(
                    "fr-FR",
                    {
                     // timeZone: "Europe/Paris",
                      hour: "2-digit",
                      minute: "2-digit",
                    }
                  )}{" "}
                  -{" "}
                  {new Date(rendezVous?.end_time).toLocaleTimeString("fr-FR", {
                  //  timeZone: "Europe/Paris",
                    hour: "2-digit",
                    minute: "2-digit",
                  })}
                </h5>
                <p className="body grey-light mb-24">{rendezVous?.title}</p>
                {rendezVous?.type == "manual_user" ? (
                  <>
                    <div className="mb-3">
                      <div className="body bold500 mb-8">Salarié</div>
                      <div className="body grey-light">
                        <img
                          src="/images/user-profile-gray.svg"
                          alt="profil"
                          className="me-2"
                        />
                        {rendezVous?.equipe?.name}
                      </div>
                    </div>
                    <div className="mb-3">
                      <div className="body bold500 mb-8">Client</div>
                      <div className="body grey-light mb-8">
                        <img
                          src="/images/user-profile-gray.svg"
                          alt="profil"
                          className="me-2"
                        />
                         {rendezVous?.manual_user_detail?.first_name}{" "}
                        {rendezVous?.manual_user_detail?.last_name}
                      </div>
                      {rendezVous?.manual_user_detail?.email &&
                      
                        <div className="body grey-light mb-8">
                        <img
                          src="/images/mail.svg"
                          alt="mail"
                          className="me-2"
                        />
                        {rendezVous?.manual_user_detail?.email}
                      </div>
                      }
                      {rendezVous?.manual_user_detail?.phone &&  
                        <div className="body grey-light mb-8">
                        <img
                          src="/images/tel.svg"
                          alt="Téléphone"
                          className="me-2"
                        />
                        {rendezVous?.manual_user_detail?.phone}
                      </div>
                      
                      }
 
                    </div>
                    {rendezVous?.lieu_intervention === "onsite" ? (
                      <div className="infos-location">
                        <span className="body grey-light">
                          <img src="/images/location.svg" alt="Address" />{" "}
                          {rendezVous?.adresse_domicile}
                        </span>
                      </div>
                    ) : rendezVous?.lieu_intervention === "chezpro" ? (
                      <div className="infos-location">
                        <span className="body grey-light">
                          <img src="/images/location.svg" alt="Address" />{" "}
                          {rendezVous?.etablissement?.code_postal}{" "}
                          {rendezVous?.etablissement?.ville}{" "}
                          {rendezVous?.etablissement?.adresse_postale}
                        </span>
                      </div>
                    ) : rendezVous?.lieu_intervention === "enligne" &&
                      rendezVous?.meeting_link ? (
                      <div className="video-conference">
                        <p className="body bold500 link">
                          Lien de la visioconférence
                        </p>
                        <a
                          href={rendezVous?.meeting_link}
                          className="video-link"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <img src="/images/link.svg" alt="Vidéoconférence" />
                          {rendezVous?.meeting_link}
                        </a>
                      </div>
                    ) : (
                      <p className="body grey66">En ligne</p>
                    )}
                  </>
                ) : (
                  <FormBootstrap.Group className="mb-3">
                    <FormBootstrap.Label className="legend">
                      Salarié
                    </FormBootstrap.Label>
                    <Field
                      as="select"
                      name="equipe_id"
                      className="form-control input"
                      disabled
                    >
                      <option value="all">Choisir un salarié</option>
                      {allEtablissementEquipes?.map((employee) => (
                        <option key={employee.id} value={employee.id}>
                          {employee.name}
                        </option>
                      ))}
                    </Field>
                    <ErrorMessage
                      name="employe"
                      className="text-danger"
                      component="div"
                    />
                  </FormBootstrap.Group>
                )}
              </Form>
            )}
          </Formik>
        </Offcanvas.Body>
        <div className="offcanvas-footer mb-24">
          <div className="container plr24">
            <div className="mt-4 w-30">
              {rendezVous?.type == "manual_user" ? (
                <Button
                  type="submit"
                  variant="secondary"
                  className="twyny-cta-secondary padding-submit width-100"
                  onClick={() => {
                    setEditManual(true);
                    handleClose();
                    setPopupActionType("manualRdv");
                  }}
                >
                  Modifier le rendez-vous
                </Button>
              ) : (
                <Button
                  type="submit"
                  variant="secondary"
                  className="twyny-cta-secondary padding-submit width-100"
                  onClick={() => {
                    setEditManual(true);
                    handleClose();
                    setPopupActionType("indisponibility");
                  }}
                >
                  Modifier l’indisponibilité
                </Button>
              )}
            </div>
            <div className="mt-4 w-30 mt-8">
              {rendezVous?.type == "manual_user" ? (
                <Button
                  onClick={() => {
                    setPopupVisible(true);
                  }}
                  className="btn-annulation padding-submit width-100"
                >
                  Annuler le rendez-vous
                </Button>
              ) : (
                <Button
                  onClick={() => {
                    setPopupVisible(true);
                  }}
                  className="btn-annulation padding-submit width-100"
                >
                  Annuler l’indisponibilité
                </Button>
              )}
            </div>
          </div>
        </div>
      </Offcanvas>
      {isPopupVisible && (
        <Popup
          isOpen={isPopupVisible}
          onClose={() => {
            setPopupVisible(false);
          }}
          onAction={handlePopupAction}
          title={
            popupActionType === "manualRdv"
              ? "Attention, vous allez annuler un rendez-vous"
              : "Attention, vous allez annuler une indisponibilité"
          }
          text={<p className="body">Êtes-vous sur de vouloir poursuivre?</p>}
          actionButtonText={
            popupActionType === "manualRdv"
              ? "Annuler le rendez-vous"
              : "Annuler l'indisponibilité"
          }
          closeButtonText="Conserver"
          closeButtonClassName="bold600 bleu500"
          color="blue"
          icon={
            <svg
              width="88"
              height="88"
              viewBox="0 0 88 88"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <rect
                width="88"
                height="88"
                rx="14.6667"
                fill="#DD1E03"
                fillOpacity="0.1"
              />
              <path
                d="M44.4001 44.4001V34.5001M44.4001 51.7381V51.8251M64.2001 44.4001C64.2001 55.3353 55.3353 64.2001 44.4001 64.2001C33.4649 64.2001 24.6001 55.3353 24.6001 44.4001C24.6001 33.4649 33.4649 24.6001 44.4001 24.6001C55.3353 24.6001 64.2001 33.4649 64.2001 44.4001Z"
                stroke="#DD1E03"
                strokeWidth="4.4"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          }
        />
      )}
    </>
  );
}

export default ShowRdvManual;
